import React from 'react';
import PropTypes from 'prop-types';

import AnnouncementModal from '../index';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../../models/DataModel';

import FlipButton from '../../../Buttons/FlipButton';

import './NotificationsAnnouncementModal.scss';

/**
 * NotificationsAnnouncementModal is a <GlobalModal> which is used to display an initial
 * fullscreen push notifications announcement/overlay to the user. Users should only see this once.
 */
export default class NotificationsAnnouncementModal extends React.Component {

  constructor(props) {

    NotificationsAnnouncementModal.propTypes = {
      /** onClose - Function called by the parent when the modal is closed */
      onClose: PropTypes.func,
    };

    super(props);
    this.state = {
      status: null,
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
    
    this.close = this.close.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.activateNotifications = this.activateNotifications.bind(this);
  }

  activateNotifications() {
    this.analyticsLogger.logMobilePushNotification('NotificationsOverlayOptIn');
    this.setState({ status: 'accepted' });
  }

  handleClose() {
    this.setState({ status: 'ignored' });
  }

  /**
   * Function called when the popup is closed. Also calls onClose() in the parent.
   */
  close() {
    const isAccepted = this.state.status == 'accepted' ? true : false;
    if (this.props.onClose) {
      this.props.onClose(isAccepted);
    }
    dataModel.hideGlobalModal();
  }

  render() {
    let modalClassName = 'notifications-announcement';
    let noThanksButton= <button className='notifications-announcement__no-thanks__button' onClick={this.handleClose}>No Thanks</button>;

    const status = this.state.status;
    if(status == 'ignored') {
      modalClassName += ' notifications-announcement--quick-fade';
      setTimeout(this.close, 500);
    }
    else if(status == 'accepted') {
      // hide the 'no thanks' button and fade
      modalClassName += ' notifications-announcement--slow-fade';
      noThanksButton = null;
      setTimeout(this.close, 2000);
    }

    return (
      <div className={modalClassName}>
        <AnnouncementModal
          headingText='Introducing'
          subHeadingText='Push Notifications'
          bodyText='Stay in the loop even when you’re outside the app with mobile notifications.'
          onClose={this.handleClose}
        >
          <FlipButton
            handleClick={this.activateNotifications}
            frontText={'Activate Push Notifications'}
            backText={'All Set!'}
          />
          <div className="notifications-announcement__no-thanks">
            {noThanksButton}
          </div>
        </AnnouncementModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AnnouncementModal/NotificationsAnnouncementModal/index.js